import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { keycloak } from 'shared/api';
import { useAppSelector } from 'app/providers/Store';
import { IStore } from 'app/providers/Store/model/store';
import { useNavigate } from 'react-router-dom';
import cls from './Logout.module.scss';

export const Logout = () => {
  const user = useAppSelector((state: IStore) => state.userSlice.user);
  const navigate = useNavigate();

  const logout = () => {
    keycloak.logout();
  };

  const goToProfile = () => {
    navigate('/profile');
  };

  return (
    <div className={cls.logout}>
      <div className={cls.userInfo} onClick={goToProfile}>
        <UserOutlined className={cls.userIcon} />
        <span className={cls.loginName}>
          {user?.lastname}
          {' '}
          {user?.firstname}
        </span>
      </div>
      <LogoutOutlined onClick={logout} className={cls.logoutIcon} />
    </div>
  );
};
